// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3-dG0OPqlrjY_JEVXSzU2{border-radius:.6rem}._3-dG0OPqlrjY_JEVXSzU2 label{background:none!important;padding-right:100px}._3-dG0OPqlrjY_JEVXSzU2 label>div:first-child>div:first-child{background:#fff}._3-dG0OPqlrjY_JEVXSzU2 input:not(:checked)+label{border-color:var(--border-primary)!important}._3-dG0OPqlrjY_JEVXSzU2 input:hover+label>div:first-child>div:first-child{background:#fff!important}._3-dG0OPqlrjY_JEVXSzU2 input:checked+label>div:first-child>div:nth-child(2){background:#fff!important;color:#000!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": "_3-dG0OPqlrjY_JEVXSzU2"
};
module.exports = ___CSS_LOADER_EXPORT___;
